import React from 'react';

interface ErrorMessageProps {
  message?: string | string[];
  className?: string;
}

const MintErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  className,
}) => {
  if (!message || (Array.isArray(message) && message.length === 0)) return null;

  return (
    <div className={`validation-summary-errors ${className}`}>
      {Array.isArray(message) ? (
        <ul>
          {message.map((msg, i) => (
            <li key={i}>{msg}</li>
          ))}
        </ul>
      ) : (
        <ul>
          <li>{message}</li>
        </ul>
      )}
    </div>
  );
};

export default MintErrorMessage;
